export default __webpack_public_path__ + "static/media/summary-black.096c9535.svg";